import Layer from '@arcgis/core/layers/Layer';
import { GISService } from '../gisServicesTypes';

export type LayerLoader = {
  /**
   * Returns true if this is a valid loader for the layer. For each servuce,
   * loaders get checked in order, and the first loader for which
   * shouldUseLoader returns true gets used to load that service. See
   */
  shouldUseLoader(service: GISService): boolean;
  /**
   * Note that load returns an array of layer results! Most layers load only one
   * layer, but sometime we break out sublayers.
   */
  load(service: GISService): Promise<Layer[]>;
};

/**
 * A loader helper function; for loaders that return a single Layer, this
 * verifies the layer is loaded, and packs it into an array.
 */
export async function ensureLoadedLayerArray(layer: Layer) {
  if (layer.loaded) {
    return [layer];
  } else {
    // eslint-disable-next-line no-console
    console.error('Failed to load layer:', layer);
    return [];
  }
}
